import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { AddButton } from "../../../../../components/mui/Buttons/Buttons";
import { Box } from "@mui/material";
import CycletAssessTypes from "./CycletAssessTypes";
import NoDataFound from "../../../../../components/NodataIndication/NoDataFound";
import StepperForm from "./Forms/AppraisalStepperForm";
import { useDispatch, useSelector } from "react-redux";
import { getCyclePreData } from "../../../../../redux/features/appraisalSlice";

const CreateNewCycle = ({ update, setOpen, open, setEditStatus, id }) => {
  const dispatch = useDispatch();
  // const [open, setOpen] = useState(false);
  const [slectedSections, setSelectedSections] = useState([]);
  const { cyclePreData, loading } = useSelector((state) => state.appraisal);

  const hasTrueValue = (section) =>
    Object.values(section?.parameters ?? {}).some((item) =>
      Object.values(item ?? {}).some((val) => val === true)
    );
  useEffect(() => {
    if (update && cyclePreData) {
      const self = hasTrueValue(cyclePreData.selfAppraisal);
      const manager = hasTrueValue(cyclePreData.managerReview);

      if (self && manager) {
        setSelectedSections([1, 2]);
      } else if (self) {
        setSelectedSections([1]);
      } else if (manager) {
        setSelectedSections([2]);
      } else {
        setSelectedSections([]);
      }
    }
  }, [update, cyclePreData]);

  useEffect(() => {
    if (!open) {
      setSelectedSections([]);
      setEditStatus(false);
    }

    if (open && update) {
      dispatch(getCyclePreData(id));
    }
  }, [open]);

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      fullScreen
      title={"Create New Cycle"}
      closeButton={true}
      popupButton={
        <>
          <AddButton size={"small"} action={() => setOpen(true)}>
            Create New Cycle
          </AddButton>
        </>
      }
      content={
        <>
          {open ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {slectedSections.length === 0 ? (
                  <CycletAssessTypes
                    setSelectedSections={setSelectedSections}
                  />
                ) : null}
              </Box>
              <Box>
                {slectedSections.length === 0 ? (
                  <NoDataFound />
                ) : (
                  <Box>
                    <StepperForm
                      update={update}
                      setOpen={setOpen}
                      open={open}
                      slectedSections={slectedSections}
                      id={id}
                    />
                  </Box>
                )}
              </Box>
            </>
          ) : null}
        </>
      }
    />
  );
};

export default CreateNewCycle;
